import { z } from 'zod';
import {
    CarCreateFormDocuments,
    // CarCreateFormErrorsMessages,
    CarCreateFormPhoto,
    CarCreateFormPhotos,
} from '@/types/car/car-create-form.type.ts';
import { CarAdmissionType } from '@/types/car/admission-type.type.ts';
import { CarBodyType } from '@/types/car/car-body-type.type.ts';
import { CarEngineType } from '@/types/car/car-engine-type.type.ts';
import { CarDriveType } from '@/types/car/car-drive-type.type.ts';
import { CarNdsType } from '@/types/car/car-nds-type.ts';
import { CarTransmissionType } from '@/types/car/car-transmission-type.type.ts';
import {
    ComplectationOptionsCreateForm,
    ComplectationOptionsCreateFormErrors,
    ComplectationOptionsCreateFormErrorsSchema,
} from '@/types/complectation.type.ts';
import {
    CarDamageCreateForm,
    CarDamageCreateFormErrors,
    CarDamageCreateFormErrorsSchema,
} from '@/types/car/car-damage-create-form.type.ts';
import {
    CarDamageUpdateForm,
    CarDamageUpdateFormErrors,
    CarDamageUpdateFormErrorsSchema,
} from '@/types/car/car-damage-update-form.type.ts';

export type CarUpdateFormPhoto = {
    id: number,
    rotation: number,
};

export type CarUpdateForm = {
    brand_id?: number,
    model_id?: number,
    model_code_id?: number,
    vin: string,
    admission_type?: CarAdmissionType,
    pts_number: string,
    body_type?: CarBodyType,
    body_color: string,
    engine_type?: CarEngineType,
    drive_type?: CarDriveType,
    mileage?: number,
    production_year?: number,
    engine_power?: number,
    engine_volume?: number,
    start_price?: number,
    nds_type?: CarNdsType,
    transmission_type?: CarTransmissionType,
    additional_equipment?: string,
    dealer_id?: number,
    complectation_id?: number,
    owners_count?: number,
    months_with_last_owner?: number,
    is_stolen?: 0 | 1,
    is_pledged?: 0 | 1,
    exist_dtp?: 0 | 1,
    comment?: string,
    tags?: string,
    was_owned_by_individual?: 0 | 1,
    options?: ComplectationOptionsCreateForm,
    new_car_damages: CarDamageCreateForm[],
    new_photos: CarCreateFormPhotos,
    new_additional_photos: CarCreateFormPhoto[],
    new_documents: CarCreateFormDocuments,
    new_car_videos: File[],
    updated_car_damages: CarDamageUpdateForm[],
    deleted_car_damages: number[],
    deleted_photos: number[],
    deleted_additional_photos: number[],
    deleted_documents: number[],
    deleted_videos: number[],
    updated_photos: CarUpdateFormPhoto[],
    updated_additional_photos: CarUpdateFormPhoto[],
};

export type CarUpdateFormErrors = {
    brand_id?: string[],
    model_id?: string[],
    model_code_id?: string[],
    vin?: string[],
    admission_type?: string[],
    pts_number?: string[],
    body_type?: string[],
    body_color?: string[],
    engine_type?: string[],
    drive_type?: string[],
    mileage?: string[],
    production_year?: string[],
    engine_power?: string[],
    engine_volume?: string[],
    start_price?: string[],
    nds_type?: string[],
    transmission_type?: string[],
    additional_equipment?: string[],
    dealer_id?: string[],
    complectation_id?: string[],
    owners_count?: string[],
    months_with_last_owner?: string[],
    is_stolen?: string[],
    is_pledged?: string[],
    exist_dtp?: string[],
    comment?: string[],
    tags?: string[],
    was_owned_by_individual?: string[],
    options?: ComplectationOptionsCreateFormErrors,
    new_car_damages?: (CarDamageCreateFormErrors | undefined)[],
    new_photos?: (string[] | string)[],
    new_additional_photos?: (string[] | undefined)[],
    new_documents?: (string[] | undefined)[],
    new_car_videos?: (string[] | undefined)[],
    updated_car_damages?: (CarDamageUpdateFormErrors | undefined)[],
    deleted_car_damages?: (string[] | undefined)[],
    deleted_photos?: (string[] | undefined)[],
    deleted_additional_photos?: (string[] | undefined)[],
    deleted_documents?: (string[] | undefined)[],
    deleted_videos?: (string[] | undefined)[],
};

export const CarUpdateFormErrorsSchema = z.object({
    brand_id: z.array(z.string()).optional(),
    model_id: z.array(z.string()).optional(),
    model_code_id: z.array(z.string()).optional(),
    vin: z.array(z.string()).optional(),
    admission_type: z.array(z.string()).optional(),
    pts_number: z.array(z.string()).optional(),
    body_type: z.array(z.string()).optional(),
    body_color: z.array(z.string()).optional(),
    engine_type: z.array(z.string()).optional(),
    drive_type: z.array(z.string()).optional(),
    mileage: z.array(z.string()).optional(),
    production_year: z.array(z.string()).optional(),
    engine_power: z.array(z.string()).optional(),
    engine_volume: z.array(z.string()).optional(),
    start_price: z.array(z.string()).optional(),
    nds_type: z.array(z.string()).optional(),
    transmission_type: z.array(z.string()).optional(),
    additional_equipment: z.array(z.string()).optional(),
    dealer_id: z.array(z.string()).optional(),
    complectation_id: z.array(z.string()).optional(),
    owners_count: z.array(z.string()).optional(),
    months_with_last_owner: z.array(z.string()).optional(),
    is_stolen: z.array(z.string()).optional(),
    is_pledged: z.array(z.string()).optional(),
    exist_dtp: z.array(z.string()).optional(),
    comment: z.array(z.string()).optional(),
    tags: z.array(z.string()).optional(),
    was_owned_by_individual: z.array(z.string()).optional(),
    options: ComplectationOptionsCreateFormErrorsSchema.optional(),
    new_car_damages: z.array(CarDamageCreateFormErrorsSchema.optional()).optional(),
    new_photos: z.array(z.string().array().optional()).optional(),
    new_additional_photos: z.array(z.string().array().optional()).optional(),
    new_documents: z.array(z.string().array().optional()).optional(),
    new_car_videos: z.array(z.string().array().optional()).optional(),
    updated_car_damages: z.array(CarDamageUpdateFormErrorsSchema.optional()).optional(),
    deleted_car_damages: z.array(z.string().array().optional()).optional(),
    deleted_photos: z.array(z.string().array().optional()).optional(),
    deleted_additional_photos: z.array(z.string().array().optional()).optional(),
    deleted_documents: z.array(z.string().array().optional()).optional(),
    deleted_videos: z.array(z.string().array().optional()).optional(),
});

// export const CarUpdateFormErrorsMessages = CarCreateFormErrorsMessages;

export function mapCarUpdateFormToFormData(updateForm: CarUpdateForm): FormData {
    const formData = new FormData();

    if (updateForm.brand_id !== undefined) {
        formData.append('brand_id', `${updateForm.brand_id}`);
    }

    if (updateForm.model_id !== undefined) {
        formData.append('model_id', `${updateForm.model_id}`);
    }

    if (updateForm.model_code_id !== undefined) {
        formData.append('model_code_id', `${updateForm.model_code_id}`);
    }

    if (updateForm.vin.length > 0) {
        formData.append('vin', updateForm.vin);
    }

    if (updateForm.admission_type !== undefined) {
        formData.append('admission_type', updateForm.admission_type);
    }

    if (updateForm.pts_number.length > 0) {
        formData.append('pts_number', updateForm.pts_number);
    }

    if (updateForm.body_type !== undefined) {
        formData.append('body_type', updateForm.body_type);
    }

    if (updateForm.body_color.length > 0) {
        formData.append('body_color', updateForm.body_color);
    }

    if (updateForm.engine_type !== undefined) {
        formData.append('engine_type', updateForm.engine_type);
    }

    if (updateForm.drive_type !== undefined) {
        formData.append('drive_type', updateForm.drive_type);
    }

    if (updateForm.mileage !== undefined) {
        formData.append('mileage', `${updateForm.mileage}`);
    }

    if (updateForm.production_year !== undefined) {
        formData.append('production_year', `${updateForm.production_year}`);
    }

    if (updateForm.engine_power !== undefined) {
        formData.append('engine_power', `${updateForm.engine_power}`);
    }

    if (updateForm.engine_volume !== undefined) {
        formData.append('engine_volume', `${updateForm.engine_volume}`);
    }

    if (updateForm.start_price !== undefined) {
        formData.append('start_price', `${updateForm.start_price}`);
    }

    if (updateForm.nds_type !== undefined) {
        formData.append('nds_type', updateForm.nds_type);
    }

    if (updateForm.transmission_type !== undefined) {
        formData.append('transmission_type', updateForm.transmission_type);
    }

    if (updateForm.additional_equipment !== undefined && updateForm.additional_equipment.length > 0) {
        formData.append('additional_equipment', updateForm.additional_equipment);
    }

    if (updateForm.dealer_id !== undefined) {
        formData.append('dealer_id', `${updateForm.dealer_id}`);
    }

    if (updateForm.complectation_id !== undefined) {
        formData.append('complectation_id', `${updateForm.complectation_id}`);
    }

    if (updateForm.owners_count !== undefined) {
        formData.append('owners_count', `${updateForm.owners_count}`);
    }

    if (updateForm.months_with_last_owner !== undefined) {
        formData.append('months_with_last_owner', `${updateForm.months_with_last_owner}`);
    }

    if (updateForm.is_stolen !== undefined) {
        formData.append('is_stolen', `${updateForm.is_stolen}`);
    }

    if (updateForm.is_pledged !== undefined) {
        formData.append('is_pledged', `${updateForm.is_pledged}`);
    }

    if (updateForm.exist_dtp !== undefined) {
        formData.append('exist_dtp', `${updateForm.exist_dtp}`);
    }

    if (updateForm.comment !== undefined && updateForm.comment.length > 0) {
        formData.append('comment', updateForm.comment);
    }

    if (updateForm.tags !== undefined && updateForm.tags.length > 0) {
        formData.append('tags', updateForm.tags);
    }

    if (updateForm.was_owned_by_individual !== undefined) {
        formData.append('was_owned_by_individual', `${updateForm.was_owned_by_individual}`);
    }

    if (updateForm.options !== undefined) {
        Object.entries(updateForm.options).forEach(([key, value]) => {
            formData.append(`options[${key}]`, value);
        });
    }

    if (updateForm.new_car_damages) {
        updateForm.new_car_damages.forEach((damage: CarDamageCreateForm, index: number) => {
            formData.append(`new_car_damages[${index}][symbolic_code]`, damage.symbolic_code ?? '');
            formData.append(`new_car_damages[${index}][type]`, damage.type ?? '');

            if (damage.photo !== undefined) {
                formData.append(`new_car_damages[${index}][photo]`, damage.photo);
            }

            if (damage.paintwork_thickness !== undefined) {
                formData.append(`new_car_damages[${index}][paintwork_thickness]`, `${damage.paintwork_thickness}`);
            }

            if (damage.comment !== undefined && damage.comment.length > 0) {
                formData.append(`new_car_damages[${index}][comment]`, `${damage.comment}`);
            }
        });
    }

    if (updateForm.updated_car_damages) {
        updateForm.updated_car_damages.forEach((damage: CarDamageUpdateForm, index: number) => {
            formData.append(`updated_car_damages[${index}][id]`, `${damage.id}`);
            formData.append(`updated_car_damages[${index}][symbolic_code]`, damage.symbolic_code ?? '');
            formData.append(`updated_car_damages[${index}][type]`, damage.type ?? '');

            if (damage.deleted_photo_id) {
                formData.append(`updated_car_damages[${index}][deleted_photo_id]`, `${damage.deleted_photo_id}`);
            }

            if (damage.photo !== undefined) {
                formData.append(`updated_car_damages[${index}][photo]`, damage.photo);
            }

            if (damage.paintwork_thickness !== undefined) {
                formData.append(`updated_car_damages[${index}][paintwork_thickness]`, `${damage.paintwork_thickness}`);
            }

            if (damage.comment !== undefined && damage.comment.length > 0) {
                formData.append(`updated_car_damages[${index}][comment]`, `${damage.comment}`);
            }
        });
    }

    if (updateForm.deleted_car_damages) {
        updateForm.deleted_car_damages.forEach((damageId: number, index: number) => {
            formData.append(`deleted_car_damages[${index}]`, `${damageId}`);
        });
    }

    if (updateForm.new_photos) {
        Object.entries(updateForm.new_photos).forEach(([type, photo]) => {
            if (photo.file !== undefined && photo.file !== null) {
                formData.append(`new_photos[${type}][file]`, photo.file);
            }

            if (photo.rotation !== undefined) {
                formData.append(`new_photos[${type}][rotation]`, `${photo.rotation}`);
            }
        });
    }

    if (updateForm.deleted_photos) {
        updateForm.deleted_photos.forEach((photoId: number, index: number) => {
            formData.append(`deleted_photos[${index}]`, `${photoId}`);
        });
    }

    if (updateForm.new_additional_photos !== undefined) {
        updateForm.new_additional_photos.forEach((photo, index: number) => {
            if (photo.file !== undefined && photo.file !== null) {
                formData.append(`new_additional_photos[${index}][file]`, photo.file);
            }

            if (photo.rotation !== undefined) {
                formData.append(`new_additional_photos[${index}][rotation]`, `${photo.rotation}`);
            }
        });
    }

    if (updateForm.deleted_additional_photos) {
        updateForm.deleted_additional_photos.forEach((photoId: number, index: number) => {
            formData.append(`deleted_additional_photos[${index}]`, `${photoId}`);
        });
    }

    if (updateForm.new_documents !== undefined) {
        Object.entries(updateForm.new_documents).forEach(([type, files]) => {
            files.forEach((file: File | null, index: number) => {
                if (file !== null) {
                    formData.append(`new_documents[${type}][${index}]`, file);
                }
            });
        });
    }

    if (updateForm.deleted_documents) {
        updateForm.deleted_documents.forEach((documentId: number, index: number) => {
            formData.append(`deleted_documents[${index}]`, `${documentId}`);
        });
    }

    if (updateForm.new_car_videos !== undefined) {
        updateForm.new_car_videos.forEach((file: File, index: number) => {
            formData.append(`new_car_videos[${index}]`, file);
        });
    }

    if (updateForm.deleted_videos) {
        updateForm.deleted_videos.forEach((videoId: number, index: number) => {
            formData.append(`deleted_videos[${index}]`, `${videoId}`);
        });
    }

    if (updateForm.updated_photos) {
        updateForm.updated_photos.forEach((photo: CarUpdateFormPhoto, index: number) => {
            formData.append(`updated_photos[${index}][id]`, `${photo.id}`);
            formData.append(`updated_photos[${index}][rotation]`, `${photo.rotation}`);
        });
    }

    if (updateForm.updated_additional_photos) {
        updateForm.updated_additional_photos.forEach((photo: CarUpdateFormPhoto, index: number) => {
            formData.append(`updated_additional_photos[${index}][id]`, `${photo.id}`);
            formData.append(`updated_additional_photos[${index}][rotation]`, `${photo.rotation}`);
        });
    }

    return formData;
}
